import React from 'react';

import { Link } from 'react-router-dom';

import { Helmet } from "react-helmet";

const OVERRIDE_COLOR = 'rgb( 183, 28, 28 )';

const newsletterAugust2021 = ({ imagePrefix }) => {
  return (
    <div className="content-container article">
      <Helmet>
        <title>The Good News - August 2021 | Elevation of the Holy Cross Sacramento</title>
      </Helmet>

      <div className="header">
        <div className="eyebrows">
          <div className="left">
            Quarterly Newsletter
          </div>
          <div className="right">
            August 2021
          </div>
        </div>

        <h1 style={{ color: OVERRIDE_COLOR }}>The Good News</h1>
        <h2>Elevation of the Holy Cross Orthodox Church, Sacramento</h2>
      </div>

      <div className="body">
        <div className="cols">
          <div className="left">
            <div className="section">

              <img src={ require( '../../../assets/images/news/newsletter-august-2021-pilgrimage.jpg' ) } alt="Holy Cross parishioners with Bishop Daniel at Fr. Ross Pilgrimage" />
              <div className="image-caption">
                Holy Cross parishioners with Bishop Daniel at Fr. Ross Pilgrimage
              </div>
            </div>

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                On the Holy Cross
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <div style={{ float: 'right', maxWidth: '50%', marginLeft: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-august-2021-holy-cross.jpg') } alt="2021 Paschal Message of His Eminence, Archbishop Benjamin" />
                </div>

                <h4>St. John Chrysostom</h4>

                <p>
                  Let us consider of what great blessings for us Christ's Cross has become the cause. For though the Lord's Cross sounds sad and bitter, it is in reality full of joy and radiance. For the Cross is the salvation of the Church; the Cross is the boast of those who hope in it; the Cross is reconciliation of enemies to God and conversion of sinners to Christ. For through the Cross we have been delivered from enmity, and through the Cross we have been joined in friendship to God. Through the Cross we have been freed from the tyranny of the devil, and through the Cross we have been delivered from death and destruction. 'When the Cross was not proclaimed, we were held fast by death; now the, Cross is proclaimed, and we have. come to despise death, as though it did not exist, while we have come to long for everlasting life. 'When the Cross was not proclaimed, we were strangers to paradise; but when the Cross appeared, at once a thief was found worthy of paradise. From such darkness the human race has crossed over to infinite light; from death it has been called to everlasting life, from corruption it has been renewed for incorruption. For the eyes of the heart are no longer covered by the darkness that comes through ignorance, but through the Cross they are flooded with the light of knowledge. The ears of the deaf are no longer shut by unbelief, for the deaf have heard the word of the Lord, and the blind have recovered their sight to see the glory of God. These are the gifts we are given through the Cross. What blessing has not been achieved for us through the Cross? The Cross is proclaimed, and faith in God is confessed and truth prevails in the whole inhabited world. The Cross is proclaimed, and martyrs are revealed and confession of Christ prevails. The Cross is proclaimed, and the resurrection is revealed, life is made manifest, the kingdom of heaven is assured. The Cross has become the cause of all these things, and through the Cross we have been taught to sing. What then is more precious than the Cross? What more profitable for our souls? So let us not be ashamed to name the Cross, but let us confess it with total confidence. Christ is hung upon the Cross, and the devil has become a corpse. Christ has been stretched on the Cross, and a standard of salvation has been given to the world. Christ has been nailed to the Cross, and every soul has been released from bonds. Christ has been fixed to the Cross, and all creation has been set free from the slavery of corruption. Christ has breathed his last on the Cross, and a new marvel has been shown to the world; for the sun's light is darkened…let us cling to the Cross, placing all our hopes on the Cross, so that taught through the Cross, fixing our thought on heaven, being brought close to Christ our Saviour, we may be found worthy to be near God in the kingdom of heaven, in Christ our Lord himself, to whom be glory and might to the ages of ages. Amen. (translation by V. Rev. Arch. Ephrem Lash; this appeared originally in ‘Light of Christ,’ Newsletter of the Orthodox Church of St. John the Baptist and St. Anthony, London.)
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Memory Eternal Joe Laychak!
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <div style={{ float: 'left', maxWidth: '50%', marginRight: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-august-2021-joe-laychak.jpg') } alt="Joe Laychak, April 11, 1920 - July 24, 2021" />
                </div>

                <h4>Joseph Laychak, April 11, 1920 - July 24, 2021</h4>

                <p>
                  Wonderful Gentleman, Memory Eternal!
                </p>
                <p>
                  A devout, spiritual, loving, smart, charitable & wise leader, Joseph died in his sleep of natural causes. His birthday shaped his life as he was born on glorious Orth. Easter Sunday to Maria Fario Laychak in Troop, PA. Grew up in Campbell, OH with his mother, stepfather, John Bobosh, & 7 siblings & step siblings. Due to Bobosh's lung disease young Joe's paper route helped support the family during extreme hard times. Entered the Civilian Conservation Corps to continue his support & went west to Nevada & radio tech. training for his big break. Forever a public servant, McClellan AFB was his 1st & last stop before retirement. He helped repair aircraft during WWII, assisted the Navy with top-secret communications, & continued career with the Weather Service & as one of the 1st electrical engineering graduates at Sac. St. Univ. He helped design fighter jets & other military hardware & received a Gold Zero Defects award from Air Force Logistics Command, all the while earning his Master's Degree.
                </p>
                <p>
                  Married & devoted husband to Sophia Laychak; wonderful parents to Larisa & Eugenia. Happily spent later years continuing his education & cruising around his beloved Alaska, U.S. & abroad with Sophia & family. His generosity, love of learning, & travel took him to Alaska for assignments, leading fundraising & assistance to the Orth. churches, missions, & seminary. His commitment to the church community was felt locally, regionally & nationally; awarded special recognition by Bishop Gregory of Sitka & All Alaska with Archpastoral Gratitude & Blessings proclamation. Joseph & Sophia were two of the founders of Sacramento's Holy Cross Orth. church. During churches' early & struggling years they ensured its survival & growth.
                </p>
                <p>
                  Was predeceased by parents, siblings, most friends, Larisa, Aubrey Lee Nation, & Sophia. Is survived by Eugenia, Gilberto R. Lagunas, relatives, & friends. He will always be missed; may he rest in peace.
                </p>
                <p>
                  Panikhida & evening service: Tuesday, August 3, 2021 6:00 pm, Elevation of the Holy Cross Orthodox Church, 9000 Jackson Road, Sacramento, 95826.
                </p>
                <p>
                  Funeral service: Wednesday, August 4, 2021, same location. In lieu of flowers, donations in his memory to Elevation of the Holy Cross Orthodox Church Building Fund.
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Building Program Updates
              </h2>

              <img src={ require( '../../../assets/images/news/newsletter-august-2021-building-program.jpg' ) } alt="Hard at work on site plans" style={{ marginTop: '1rem' }} />
              <div className="image-caption">
                Hard at work on site plans
              </div>

              <div className="article-body">
                <p>
                  Our civil engineer Antonio has nearly completed the land surveys and drainage impact study. We’ve also hired an architect to produce 3D color renderings of our new church and site plan, which we hope to share this Fall. We’re also in the process of hiring a geotechnical firm to conduct a soil survey.  On the fundraising side, <strong>we're more than halfway to our 2021 fundraising goal – having raised $53,251 this year through July, bringing us to $561,997 in our Building Fund!</strong> We plan to take a special collection for our Building Fund on our Feast Day September 14th, and will be holding our Wine Stroll fundraiser once again October 16th.
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Many Years!
              </h2>

              <div className="article-body" style={{ clear: 'all', paddingBottom: '200px' }}>
                <div style={{ float: 'left', maxWidth: '50%', marginRight: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-august-2021-raul-and-lily.jpg') } alt="Marriage of Raul and Liliana" />
                  <div className="image-caption">
                    Marriage of Raul and Liliana
                  </div>
                </div>

                <h4>Marriage of Raul and Liliana</h4>

                <p>
                  Many years to Raul and Lily on their marriage this past July, which we celebrated at the Holy Assumption Serbian Orthodox Church.  
                </p>
                <p>
                  And many years to all the newly-born children and their families we’ve welcomed these past few months: baby Priscilla Brown, baby Sophia Honeycutt, baby Tabitha McNaughton, baby Photini Duke, and baby Anna Borovskikh!  What tremendous joy to welcome these beautiful children into the world! 
                </p>
              </div>
            </div>

            <div className="section" style={{ borderBottom: 'none' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Save the Date
              </h2>

              <div className="article-body">
                <ul style={{ paddingLeft: '16px' }}>
                  <li>
                    Parish Work Day - Sat. 9/11 
                  </li>
                  <li>
                    Vigil for Elevation of the Holy Cross - Mon. 9/13 at 6:00 PM
                  </li>
                  <li>
                    Hierarchical Divine Liturgy - Tue. 9/14 at 9:00 AM (festal luncheon to follow)
                  </li>
                  <li>
                    Wine Stroll Fundraiser – Oct. 16th
                  </li>
                  <li>
                    Christmas Around the World – Nov. 13th
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="article-footer">
          9000 Jackson Rd, Sacramento, CA 95826 <Link to={ `/` }>holycrosssacramento.org</Link><br/>
          Mailing: 2443 Fair Oaks Blvd #295, Sacramento, CA 95825
        </div>
      </div>
    </div>
  );
}

export default newsletterAugust2021;
